import {Pipe, PipeTransform} from '@angular/core';
import {Boolean} from '@atlas/businesstypes';

/**
 * @ngModule BusinessTypesModule
 */
@Pipe({name: 'atlasBoolean'})
export class BooleanPipe implements PipeTransform {
  public transform(value: any): boolean {
    return Boolean.isBoolean(value) ? value.asBoolean() : value;
  }
}
